import { Grid } from "@mui/material";
import React from "react";
import { formatOutput } from "../../../utils/computation/analysis";
import GraphHeader from "../../graphs/GraphHeader";
import ImageGraph from "../../graphs/ImageGraph";

const ANOVAOneWayResult = ({ oneway }) => {
  return (
    <div>
      <GraphHeader
        column={oneway.column}
        dateTime={oneway.dateTime}
        title={"ANOVA (One-way)"}
        analysisId={oneway.id}
        graphs={oneway.graphs}
      />

      <Grid
        container
        spacing={{ xs: 2, md: 3 }}
        columns={{ xs: 4, sm: 8, md: 12 }}
        sx={{ color: "#535353" }}
      >
        <Grid item xs={12} sm={12} md={12}>
          <h4>Data</h4>
          <h4>Column {oneway.column}</h4>
        </Grid>

        <Grid item xs={3} sm={3} md={3}>
          <h4>Statistics</h4>
          <h3>{formatOutput(oneway.anova.statistic)}</h3>
        </Grid>
        <Grid item xs={3} sm={3} md={3}>
          <h4>P-value</h4>
          <h3>{formatOutput(oneway.anova.pvalue)}</h3>
        </Grid>
      </Grid>
      {oneway.graphs.isBoxplot && (
        <ImageGraph
          url={oneway.boxplotResult.groupBoxplot}
          title="Boxplot"
          column={oneway.column}
          // percent={result.inputs.confindence * 100}
          percent={95}
        />
      )}
      {oneway.graphs.isIVP && (
        <ImageGraph
          url={oneway.ivpResult.individualPlot}
          title="Individual Value Plot"
          column={oneway.column}
          // percent={result.inputs.confindence * 100}
          percent={95}
        />
      )}

      <Grid item xs={12} sm={12} md={12}>
        <h4>{oneway?.conclusion}</h4>
      </Grid>
    </div>
  );
};

export default ANOVAOneWayResult;
